import React, { Component } from 'react'
import styled from 'styled-components'
import { vhToPx, evalImage } from '@/utils'
import { extendObservable, intercept } from 'mobx'
import { inject, observer } from 'mobx-react'
import ActivityIndicator from '@/Components/Common/ActivityIndicator'
import GameEventItem from './GameEventItem'
import TeamIcon from './ImportTeamIcon'
import ImportExportArrowsIcon from '@/assets/images/import-export-arrows.svg'
import FilterComp from './FilterComp'
import dateFormat from 'dateformat'
import _ from 'lodash'

@inject('ImportStore', 'GameStore', 'PrePlayStore')
@observer
export default class ImportPlaystack extends Component {
  constructor(props) {
    super(props)
    extendObservable(this, {
      events: null,
      isFindingEvents: false,
      isFinding: false,
      selectedGameEvent: null,
      activityIndicator: null,
      started: false,
      playstack: [],
      selectedPlaysCount: 0,
      confirmMessage: null,
      error: null,
    })
    this.state = {
      showImportFilesList: false,
      checkedItems: {},
      qaFileList: [],
      qaFile: null,
      fetchedFiles: [],
    }

    this.sportTypes = []
  }

  handleCancelClick() {
    this.props.canceled()
  }

  handlePlaystackCheckChange(e) {
    if (e.target.checked) {
      this.playstack.forEach((play, idx) => {
        play.checked = 1
        this[`play-checkbox${idx}`].checked = 1
      })
      this.selectedPlaysCount = this.playstack.length
    } else {
      this.playstack.forEach((play, idx) => {
        play.checked = 0
        this[`play-checkbox${idx}`].checked = 0
      })
      this.selectedPlaysCount = 0
    }
  }

  handlePlayCheckChange(idx, e) {
    this.playstack[idx].checked = e.target.checked ? 1 : 0
    this.selectedPlaysCount = e.target.checked
      ? this.selectedPlaysCount + 1
      : this.selectedPlaysCount - 1
    if (this.playstack.length === this.selectedPlaysCount) {
      if (this.playCheckboxHeader) {
        this.playCheckboxHeader.checked = 1
      }
    } else if (this.playstack.length > this.selectedPlaysCount) {
      if (this.playCheckboxHeader) {
        this.playCheckboxHeader.checked = 0
      }
    }
  }

  async executeImportFromFiles() {
    if (this.refContinueLabel) {
      this.refContinueLabel.innerHTML = 'started importing. please wait...'
    }
    const playsToImport = this.playstack.filter(_p => {
      return _p.checked
    })
    const chunkSize = 1000
    let count = 0
    for (let i = 0; i < playsToImport.length; i += chunkSize) {
      const chunk = playsToImport.slice(i, i + chunkSize)
      const args = {
        gameId: this.props.item.gameId,
        plays: JSON.stringify(chunk),
      }
      await this.props.GameStore.importQA(args).then(response => {
        count += response
      })
    }
    if (count === playsToImport.length) {
      this.refContinueLabel = null
      this.selectedGameEvent = null
      this.playstack = null
      this.setState({ checkedItems: {} })
    }
  }

  handleConfirm(mode) {
    if (mode) {
      this.confirmMessage = null
      if (this.state.showImportFilesList) {
        this.executeImportFromFiles()
      } else this.executeImport()
    } else {
      this.confirmMessage = null
    }
  }

  handleImportClick() {
    this.confirmMessage = (
      <ConfirmMessage
        confirm={this.handleConfirm.bind(this, 1)}
        cancel={this.handleConfirm.bind(this, 0)}
      />
    )
  }

  executeImport() {
    if (this.refImportButton) {
      this.refImportButton.style.pointerEvents = 'none'
      document.styleSheets[0].addRule(
        '#ref-import-button:before',
        'content: "import started";'
      )
    }
    if (this.refCancelButton) {
      this.refCancelButton.style.pointerEvents = 'none'
      this.refCancelButton.style.opacity = 0.2
    }
    if (this.refContinueLabel) {
      this.refContinueLabel.innerHTML = 'started importing. please wait...'
    }

    this.activityIndicator = <ActivityIndicator height={5} color={'#ffffff'} />
    this.started = true

    this.props.ImportStore.importPlaystack({
      source: this.selectedGameEvent.gameId,
      destination: this.props.item.gameId,
      playsToImport: this.playstack.map(_p => {
        return {
          game_play_id: _p.game_play_id,
          checked: _p.checked,
        }
      }),
    }).then(res => {
      if (res && res.playCount > 0) {
        this.selectedGameEvent = null
        this.playstack = null
      }

      this.started = false

      if (this.refImportButton) {
        this.refImportButton.style.pointerEvents = 'none'
        this.refImportButton.style.display = 'none'
        document.styleSheets[0].addRule(
          '#ref-import-button:before',
          'content: "import playstack";'
        )
      }
      if (this.refCancelButton) {
        this.refCancelButton.style.pointerEvents = 'auto'
        this.refCancelButton.style.opacity = 1
      }
      this.activityIndicator = null
    })
  }

  refHandleSelectedGameEvent(gameEvent) {
    this.isFinding = true
    this.selectedGameEvent = null
    this.selectedPlaysCount = 0
    this.props.ImportStore.getGamePlaysByGameId({ gameId: gameEvent.gameId })
      .then(async response => {
        if (response && response.length > 0) {
          response[0] = response[0].reverse()
          response[1] = response[1].reverse()
          response[2] = response[2].reverse()
          response[3] = response[3].reverse()
          this.props.ImportStore.setSelectedGameId(gameEvent.gameId)
          this.selectedGameEvent = gameEvent

          for (let i = 0; i < response[0].length; i++) {
            response[0][i].choices = []
            if (response[1] && Array.isArray(response[1])) {
              const qs = await response[1].filter(
                o =>
                  o.game_play_id === response[0][i].game_play_id &&
                  o.preset !== 'multiplier'
              )[0]
              if (qs) {
                if (response[2] && Array.isArray(response[2])) {
                  const arr_sqs = await response[2].filter(
                    o => o.question_id === qs.question_id
                  )
                  if (arr_sqs && Array.isArray(arr_sqs)) {
                    arr_sqs.forEach(c => {
                      response[0][i].choices.push(c)
                    })
                  }
                }
              }
            }
          }

          this.playstack = await response[0]
        }
      })
      .finally(_ => {
        this.isFinding = false
      })
  }

  handleDoFilter(args) {
    /*
    this.isFindingEvents = true
    this.selectedGameEvent = null
    this.props.ImportStore.getEventsBySportType({
      sportType: this.props.item.sportType,
      subSportGenre: this.props.item.subSportGenre,
      excludedGameId: this.props.item.gameId,
    })
      .then(data => {
        this.isFindingEvents = false
        this.events = data
      })
      .catch(err => {
        this.isFindingEvents = false
        this.showErrorPage = true
      })
*/

    this.error = null
    this.events = []

    const requiredArgs = []
    const argsFilter = JSON.parse(JSON.stringify(args))
    if (!argsFilter.sportType) {
      requiredArgs.push('SPORT TYPE')
    }

    let tmpErr = ''
    if (requiredArgs.length > 0) {
      tmpErr =
        '<span style="font-family: pamainbold;font-size: 2.5vh">REQUIRED FIELDS:</span>'
      tmpErr =
        tmpErr + '<ul style="font-family: pamainregular;font-size: 2.5vh">'
      requiredArgs.forEach(r => {
        tmpErr = tmpErr + `<li>${r}</li>`
      })
      tmpErr = tmpErr + '</ul>'

      this.error = tmpErr

      return
    }

    argsFilter.startDate = argsFilter.startDate
      ? dateFormat(argsFilter.startDate, 'yyyy-mm-dd')
      : ''
    argsFilter.endDate = argsFilter.endDate
      ? dateFormat(argsFilter.endDate, 'yyyy-mm-dd')
      : ''

    this.isFindingEvents = true
    this.selectedGameEvent = null
    this.props.ImportStore.getEventsBySportType(argsFilter)
      .then(data => {
        this.isFindingEvents = false
        this.events = data
      })
      .catch(err => {
        this.isFindingEvents = false
        this.showErrorPage = true
      })
  }

  async handleImportQAClick(isActive) {
    this.setState({ showImportFilesList: isActive })
    this.playstack = []
    this.selectedGameEvent = null
    this.setState({ checkedItems: {} })
  }

  async handleFileSelection(file) {
    if (file) {
      this.isFinding = true
      this.selectedGameEvent = null
      this.playstack = this.playstack || []
      this.filesDataSource = this.filesDataSource || {}
      if ((this.state.checkedItems || {})[file.fileId]) {
        this.playstack = _.reject(this.playstack, { fileId: file.fileId })
      } else {
        // if file data not exists getting it from server and storing it in sourceData
        if (!this.filesDataSource[file.fileId]) {
          await this.props.GameStore.readQAFile(file.fileId).then(data => {
            if (data && data.data) {
              const parsedPlays = this.tsvToJson(data.data, file.fileId)
              const newFile = {
                ...file,
                plays: parsedPlays,
              }
              this.filesDataSource[file.fileId] = newFile
            }
          })
        }
        this.playstack = this.filesDataSource[file.fileId]
          ? [...this.filesDataSource[file.fileId].plays, ...this.playstack]
          : this.playstack
      }
      // updating the file selection
      await this.setState(prevState => {
        const checkedItems = {
          ...prevState.checkedItems,
          [file.fileId]: !prevState.checkedItems[file.fileId],
        }
        return { checkedItems }
      })
      this.isFinding = false
      this.selectedGameEvent = {
        gameId: 'Q&A',
        playCount: (this.playstack || []).length,
      }
      this.selectedPlaysCount = (
        this.playstack.filter(_p => {
          return _p.checked
        }) || []
      ).length
      this.handlePlaystackCheckbox()

      if (this.selectedPlaysCount === (this.playstack || []).length)
        this.playCheckboxHeader.checked = 1
      else this.playCheckboxHeader.checked = 0
      if (!this.playstack || this.playstack.length === 0) {
        this.selectedGameEvent = null
      }

      // Check for corrupted plays and show alert
      if (
        this.state.checkedItems[file.fileId] &&
        this.filesDataSource[file.fileId]
      ) {
        const parsedPlays = this.filesDataSource[file.fileId].plays
        let corruptedAlerts = []
        parsedPlays.forEach(p => {
          if (p.isCorrupted) {
            corruptedAlerts.push(`- Row ${p.rowNumber}: ${p.corruptedReason}`)
          }
        })
        if (corruptedAlerts.length > 0) {
          setTimeout(() => {
            window.alert(
              `WARNING! The selected Q&A file contains corrupted plays:\n\n${corruptedAlerts.join(
                '\n'
              )}\n\nYou cannot import these plays until they are fixed in the file.`
            )
          }, 200) // Delay to let UI render the file preview first
        }
      }
    }
  }

  handlePlaystackCheckbox() {
    this.playstack.forEach((play, idx) => {
      if (play.checked) this[`play-checkbox${idx}`].checked = 1
    })
  }

  tsvToJson(tsvString, fileId) {
    const rows = tsvString.split('\r\n')
    const headers = (rows[0] || '').trim().split(/\s*\t\s*/)

    let jsonData = rows.slice(1).map((row, index) => {
      const rowData = {}
      const values = row.split('\t')

      headers.forEach((header, colIndex) => {
        rowData[header] =
          typeof values[colIndex] === 'string'
            ? values[colIndex].trim()
            : values[colIndex]
      })
      rowData.rowNumber = index + 2 // 1-indexed plus header row

      return rowData
    })
    jsonData.forEach(item => {
      item.question = item.question ? item.question.trim() : item.question
      const answersArray = Object.entries(item)
        .filter(
          ([key, value]) => key.startsWith('answer') && value.trim() !== ''
        )
        .map(([key, value], index) => ({
          sequence: index + 1,
          value: value.trim(),
        }))
      const playType =
        (item.type || '').toLowerCase() === 'live'
          ? 'LivePlay'
          : (item.type || '').toLowerCase()
      const playTypeLowerCase = (playType || '').toLowerCase()
      const { time_limit, awards } = this.props.GameStore.sportType
      const { teams } = this.props.PrePlayStore
      item.choices =
        answersArray &&
        answersArray.map(_ch => {
          if (_ch.value) {
            const field = _ch.value.match(/^\{(\w+)\}$/) || ''
            if (field && teams && teams.length > 1) {
              let teamIndex = field[1].match(/^player|team(\d+)$/i)[1]
              _ch.value = (teams[teamIndex - 1] || {}).teamName
            }
            _ch.value = this.props.GameStore.processChoiceTplField(_ch.value)
          }
          return _ch
        })
      item.fileId = fileId
      item.gameId = this.props.item.gameId
      item.multiplierChoices = [
        {
          id: 1,
          preset: item.category || 'Q&A',
          question: item.question,
          choices: item.choices,
          type: playType,
          awards: awards[playTypeLowerCase],
          price: null,
          time_limit: time_limit ? time_limit[playTypeLowerCase] : {},
          locked: false,
        },
      ]
      item.parent_question = item.question
      item.participantId = null
      item.playTitle = item.question
      const placementKey = Object.keys(item).find(
        key => (key || '').toLowerCase() === 'placement'
      )
      const momentKey = Object.keys(item).find(
        key => (key || '').toLowerCase() === 'moment'
      )
      const placement = placementKey ? item[placementKey] : undefined
      const moment = momentKey ? item[momentKey] : undefined

      if (item.correctanswer || placement || moment) {
        item.pmetadata = item.pmetadata || {}
        item.pmetadata.public = item.pmetadata.public || {}

        if (item.correctanswer) {
          item.pmetadata.public.opinionQuestion =
            item.correctanswer === '0' ? true : false
          item.pmetadata.public.correctanswer = item.correctanswer
        }

        if (placement) {
          item.pmetadata.public.placement = placement
        }

        if (moment) {
          item.pmetadata.public.moment = moment
        }
      }
      item.preset_id = item.category || 'Q&A'
      item.preset = {
        preset: item.category || 'Q&A',
        type: item.type,
        choices: answersArray,
        question: item.question,
        time_limit: time_limit ? time_limit[playTypeLowerCase] : {},
        awards: awards ? awards[playTypeLowerCase] : {},
      }
      if (awards[playTypeLowerCase]) {
        item.stars = awards[playTypeLowerCase]['stars']
          ? awards[playTypeLowerCase]['stars']['v']
          : 0
        item.points = awards[playTypeLowerCase]['points']
          ? awards[playTypeLowerCase]['points']['v']
          : 0
        item.tokens = awards[playTypeLowerCase]['tokens']
          ? awards[playTypeLowerCase]['tokens']['v']
          : 0
      }
      item.starMax = 1
      item.type = playType

      const validTypes = [
        'liveplay',
        'live',
        'prize',
        'sponsor',
        'gamemaster',
        'announce',
      ]
      let corruptionReason = null

      if (!validTypes.includes(playTypeLowerCase)) {
        corruptionReason = `Unknown play type: "${item.type}"`
      } else if (!item.question || item.question.trim() === '') {
        corruptionReason = 'Question text is empty'
      } else if (playTypeLowerCase !== 'announce') {
        if (!item.choices || item.choices.length < 2) {
          corruptionReason = 'Must have at least 2 choices'
        } else {
          for (let i = 0; i < item.choices.length; i++) {
            if (!item.choices[i].value || item.choices[i].value.trim() === '') {
              corruptionReason = `Choice ${i + 1} is empty`
              break
            }
          }
        }
      }

      if (corruptionReason) {
        item.isCorrupted = true
        item.corruptedReason = corruptionReason
      }
    })
    return jsonData
  }

  loadTotalPlays() {
    return (
      <Section justifyContent="center" marginTop="1.5">
        <Label
          font="pamainlight"
          size="2"
          color={'#d3d3d3'}
          uppercase
        >{`total number of play(s): ${this.selectedGameEvent.playCount}`}</Label>
      </Section>
    )
  }

  async componentDidMount() {
    await this.props.GameStore.readQAFileList()
    this.setState({ qaFileList: await this.props.GameStore.readQAFileList() })
  }

  shouldComponentUpdate(nextState) {
    if (this.state.qaFileList !== nextState.qaFileList) return true
    if (this.state.selectedPlaysCount !== nextState.selectedPlaysCount)
      return true
    return false
  }

  render() {
    let { item } = this.props
    const { showImportFilesList, qaFileList } = this.state

    let hasCorruptedSelectedPlays = false
    let corruptedWarningMessage =
      'Cannot import: One or more selected plays are corrupted'
    if (this.playstack) {
      const corruptedPlays = this.playstack.filter(
        p => p.checked && p.isCorrupted
      )
      hasCorruptedSelectedPlays = corruptedPlays.length > 0
      if (hasCorruptedSelectedPlays) {
        if (corruptedPlays.length > 3) {
          corruptedWarningMessage =
            `Cannot import: ` +
            corruptedPlays
              .slice(0, 3)
              .map(p => `Row ${p.rowNumber} (${p.corruptedReason})`)
              .join(', ') +
            `, and more...`
        } else {
          corruptedWarningMessage =
            `Cannot import: ` +
            corruptedPlays
              .map(p => `Row ${p.rowNumber} (${p.corruptedReason})`)
              .join(', ')
        }
      }
    }

    return (
      <Container>
        <Wrapper>
          {this.confirmMessage}
          <Section justifyContent="space-between" style={{ height: '95%' }}>
            <Section
              className="left-panel"
              direction="column"
              widthInPct="40"
              position={'relative'}
              height={'93%'}
            >
              {this.isFindingEvents ? (
                <Blocker backgroundColor="transparent" />
              ) : null}
              <FilterSection>
                <FilterComp
                  args={{
                    sportType: this.props.item.sportType,
                    subSportGenre: this.props.item.subSportGenre,
                  }}
                  doFilter={this.handleDoFilter.bind(this)}
                  handleImportQAClick={this.handleImportQAClick.bind(this)}
                />
              </FilterSection>

              {this.error ? (
                <Section>
                  <div
                    style={{
                      color: '#C61818',
                      marginLeft: '4vh',
                      marginTop: '2vh',
                    }}
                    dangerouslySetInnerHTML={{ __html: this.error }}
                  ></div>
                </Section>
              ) : this.isFindingEvents ? (
                <Section
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  style={{ width: '100%', height: '100%' }}
                >
                  <ActivityIndicator color={'#d3d3d3'} height={5} />
                  <Label size="2.5" color={'#d3d3d3'} uppercase>
                    fetching game events. please wait...
                  </Label>
                </Section>
              ) : showImportFilesList ? (
                <div
                  style={{
                    padding: '4% 8%',
                    overflow: 'hidden auto',
                    scrollbarWidth: 'none',
                  }}
                >
                  {(qaFileList || []).map((file, index) => {
                    if (file)
                      return (
                        <FilterRow key={file.fileId}>
                          <CheckMark
                            checked={
                              this.state.checkedItems[file.fileId] || false
                            }
                            onClick={this.handleFileSelection.bind(this, file)}
                          />
                          <Label
                            font="pamainlight"
                            size="2"
                            color="#d3d3d3"
                            style={{
                              whiteSpace: 'nowrap',
                              marginLeft: '1.2vw',
                            }}
                            uppercase
                            overflow={'auto hidden'}
                          >
                            {file.fileName}
                          </Label>
                        </FilterRow>
                      )
                  })}
                </div>
              ) : this.events && this.events.length > 0 ? (
                <Section direction="row" justifyContent="center" marginTop="3">
                  {(this.events || []).map((item, idx) => {
                    return (
                      <GameEventItemWrap
                        key={`importplaystack-${item.keyEventType}-${item.keySportType.code}`}
                        marginRight={idx === 0 ? 1 : 0}
                        width={65 * 0.9 + 'vh'}
                      >
                        {this.started ? <Blocker key={`blocker-idx`} /> : null}
                        <GameEventItem
                          eventItem={item}
                          selectedGameEvent={this.refHandleSelectedGameEvent.bind(
                            this
                          )}
                          scaleSize={0.9}
                          forImport
                        />
                      </GameEventItemWrap>
                    )
                  })}
                </Section>
              ) : !this.events ? null : (
                <Section
                  justifyContent="center"
                  alignItems="center"
                  style={{ height: '100%' }}
                >
                  <Label
                    font="pamainregular"
                    size="3"
                    color={'#d3d3d3'}
                    uppercase
                  >
                    GAME EVENT(S) NOT FOUND.
                  </Label>
                </Section>
              )}
            </Section>

            <Section
              className="middle-panel"
              widthInPct="0.1"
              height={'93%'}
              overflowY={'auto'}
              backgroundColor={'#d3d3d3'}
            />

            <Section
              className="right-panel"
              widthInPct="60"
              position={'relative'}
              height={'93%'}
            >
              {this.selectedGameEvent ? (
                <Section direction="column">
                  <Section justifyContent="center">
                    <Label
                      font="pamainregular"
                      size="3"
                      color={'#d3d3d3'}
                      uppercase
                    >
                      you are attempting to import playstack from:
                    </Label>
                  </Section>
                  <Section justifyContent="center" marginTop="2">
                    <Label
                      font={'pamainregular'}
                      size={3}
                      color={'#d3d3d3'}
                      uppercase
                      nowrap
                    >
                      {this.selectedGameEvent.gameId}
                    </Label>
                  </Section>
                  {this.selectedGameEvent.gameId !== 'Q&A' ? (
                    <div>
                      <Section
                        justifyContent={'center'}
                        flexDirection={'row'}
                        marginTop={1.5}
                      >
                        <TeamSection>
                          <TeamIconWrap>
                            <TeamIcon
                              teamInfo={this.selectedGameEvent.participants[0]}
                              size={3}
                              outsideBorderColor={'#ffffff'}
                              outsideBorderWidth={0.2}
                            />
                            &nbsp;
                            <Label
                              font={'pamainlight'}
                              size={3}
                              marginBottom={3}
                              color={'#d3d3d3'}
                              uppercase
                              nospacing
                            >
                              {this.selectedGameEvent.participants[0].name}
                            </Label>
                          </TeamIconWrap>
                          <TeamVS>
                            <Label font={'pamainextrabold'} size={2} uppercase>
                              &nbsp;&nbsp;vs&nbsp;&nbsp;
                            </Label>
                          </TeamVS>
                          <TeamIconWrap>
                            <TeamIcon
                              teamInfo={this.selectedGameEvent.participants[1]}
                              size={3}
                              outsideBorderColor={'#ffffff'}
                              outsideBorderWidth={0.2}
                            />
                            &nbsp;
                            <Label
                              font={'pamainlight'}
                              size={3}
                              marginBottom={3}
                              color={'#d3d3d3'}
                              uppercase
                              nospacing
                            >
                              {this.selectedGameEvent.participants[1].name}
                            </Label>
                          </TeamIconWrap>
                        </TeamSection>
                      </Section>
                      {this.loadTotalPlays()}
                    </div>
                  ) : (
                    <div>{this.loadTotalPlays()}</div>
                  )}
                  <Section direction="column" alignItems="center" marginTop={1}>
                    <PlayHeader>
                      <PlayCheckBox widthInPct="4.5" backgroundColor={'#000'}>
                        <input
                          type="checkbox"
                          onChange={this.handlePlaystackCheckChange.bind(this)}
                          ref={ref => (this.playCheckboxHeader = ref)}
                        />
                      </PlayCheckBox>
                      <div style={{ width: '100%' }} />
                    </PlayHeader>
                    <ScrollingPlayWrap>
                      <ContentPlayWrap>
                        {(this.playstack || []).map((play, idx) => {
                          return (
                            <PlayCompWrap
                              key={`play-comp-${play.game_play_id}-${idx}`}
                            >
                              <PlayCheckBox widthInPct="5">
                                <input
                                  type="checkbox"
                                  value={play.checked}
                                  ref={ref =>
                                    (this[`play-checkbox${idx}`] = ref)
                                  }
                                  onChange={this.handlePlayCheckChange.bind(
                                    this,
                                    idx
                                  )}
                                />
                              </PlayCheckBox>
                              <PlayComp item={play} />
                            </PlayCompWrap>
                          )
                        })}
                      </ContentPlayWrap>
                    </ScrollingPlayWrap>
                  </Section>
                  <Section justifyContent="center" marginTop="1.5">
                    <Label
                      font="pamainlight"
                      size="2"
                      color={'#d3d3d3'}
                      uppercase
                    >{`selected play(s): ${this.selectedPlaysCount}`}</Label>
                  </Section>
                  {/*
                    <Section justifyContent="center" marginTop="6">
                      <Label
                        font="pamainregular"
                        size="2.5"
                        color={'#d3d3d3'}
                        uppercase
                        innerRef={ref => (this.refContinueLabel = ref)}
                      >
                        do you want to continue?
                      </Label>
                    </Section>
*/}
                  <Section
                    justifyContent="center"
                    marginTop="6"
                    direction="column"
                    alignItems="center"
                  >
                    {hasCorruptedSelectedPlays && (
                      <Label
                        size="1.2"
                        color="#FF0000"
                        uppercase
                        marginBottom="1"
                      >
                        {corruptedWarningMessage}
                      </Label>
                    )}
                    <ImportButton
                      id={'ref-import-button'}
                      locked={
                        this.selectedPlaysCount < 1 || hasCorruptedSelectedPlays
                      }
                      innerRef={ref => (this.refImportButton = ref)}
                      onClick={
                        this.selectedPlaysCount > 0 &&
                        !hasCorruptedSelectedPlays
                          ? this.handleImportClick.bind(this)
                          : null
                      }
                    >
                      {this.activityIndicator}
                    </ImportButton>
                  </Section>
                </Section>
              ) : this.isFinding ? (
                <Section
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                >
                  <ActivityIndicator color={'#d3d3d3'} height={5} />
                  <Label size="2.5" color={'#d3d3d3'} uppercase>
                    fetching playstack. please wait...
                  </Label>
                </Section>
              ) : (
                <IconImport />
              )}
            </Section>
          </Section>

          <Section
            justifyContent={'center'}
            position={'absolute'}
            bottom={'0px'}
            padding={'2vh 0 2vh 0'}
            zIndex={201}
          >
            {/*
            <Label
              font={'pamainregular'}
              size={2}
              color={'#ff0000'}
              uppercase
              nowrap
              cursor={'pointer'}
              innerRef={ref => (this.refCancelButton = ref)}
              onClick={this.handleCancelClick.bind(this)}
            >
              close and return back to game event
            </Label>
*/}
            <CloseButton
              innerRef={ref => (this.refCancelButton = ref)}
              onClick={this.handleCancelClick.bind(this)}
            />
          </Section>
        </Wrapper>
      </Container>
    )

    /*
    return (
      <Container>
        <Wrapper>
          {this.confirmMessage}
          {this.events && this.events.length > 0 ? (
            <Section justifyContent="space-between" style={{ height: '80%' }}>
              <Section
                className="left-panel"
                direction="column"
                alignItems="center"
              >
                <Label
                  font="pamainregular"
                  size="3"
                  color={'#d3d3d3'}
                  uppercase
                >
                  select a game event to import playstack
                </Label>
                <Section direction="row" justifyContent="center" marginTop="3">
                  {this.events.map((item, idx) => {
                    return (
                      <GameEventItemWrap
                        key={`importplaystack-${item.keyEventType}-${item.keySportType.code}`}
                        marginRight={idx === 0 ? 1 : 0}
                        width={ (65 * 0.9) + 'vh' }
                      >
                        {this.started ? <Blocker key={`blocker-idx`} /> : null}
                        <GameEventItem
                          eventItem={item}
                          selectedGameEvent={this.refHandleSelectedGameEvent.bind(
                            this
                          )}
                          scaleSize={0.9}
                          forImport
                        />
                      </GameEventItemWrap>
                    )
                  })}
                </Section>
              </Section>

              <Section
                className="middle-panel"
                widthInPct="0.1"
                style={{ backgroundColor: '#d3d3d3' }}
              />

              <Section className="right-panel" style={{ position: 'relative' }}>
                {this.selectedGameEvent ? (
                  <Section direction="column">
                    <Section justifyContent="center">
                      <Label
                        font="pamainregular"
                        size="3"
                        color={'#d3d3d3'}
                        uppercase
                      >
                        you are attempting to import playstack from:
                      </Label>
                    </Section>
                    <Section justifyContent="center" marginTop="2">
                      <Label
                        font={'pamainregular'}
                        size={3}
                        color={'#d3d3d3'}
                        uppercase
                        nowrap
                      >
                        {this.selectedGameEvent.gameId}
                      </Label>
                    </Section>
                    <Section
                      justifyContent={'center'}
                      flexDirection={'row'}
                      marginTop={1.5}
                    >
                      <TeamSection>
                        <TeamIconWrap>
                          <TeamIcon
                            teamInfo={this.selectedGameEvent.participants[0]}
                            size={3}
                            outsideBorderColor={'#ffffff'}
                            outsideBorderWidth={0.2}
                          />
                          &nbsp;
                          <Label
                            font={'pamainlight'}
                            size={3}
                            marginBottom={3}
                            color={'#d3d3d3'}
                            uppercase
                            nospacing
                          >
                            {this.selectedGameEvent.participants[0].name}
                          </Label>
                        </TeamIconWrap>
                        <TeamVS>
                          <Label font={'pamainextrabold'} size={2} uppercase>
                            &nbsp;&nbsp;vs&nbsp;&nbsp;
                          </Label>
                        </TeamVS>
                        <TeamIconWrap>
                          <TeamIcon
                            teamInfo={this.selectedGameEvent.participants[1]}
                            size={3}
                            outsideBorderColor={'#ffffff'}
                            outsideBorderWidth={0.2}
                          />
                          &nbsp;
                          <Label
                            font={'pamainlight'}
                            size={3}
                            marginBottom={3}
                            color={'#d3d3d3'}
                            uppercase
                            nospacing
                          >
                            {this.selectedGameEvent.participants[1].name}
                          </Label>
                        </TeamIconWrap>
                      </TeamSection>
                    </Section>
                    <Section justifyContent="center" marginTop="1.5">
                      <Label
                        font="pamainlight"
                        size="2"
                        color={'#d3d3d3'}
                        uppercase
                      >{`total number of play(s): ${this.selectedGameEvent.playCount}`}</Label>
                    </Section>

                    <Section
                      direction="column"
                      alignItems="center"
                      marginTop={1}
                    >
                      <PlayHeader>
                        <PlayCheckBox widthInPct="4.5" backgroundColor={'#000'}>
                          <input
                            type="checkbox"
                            onChange={this.handlePlaystackCheckChange.bind(
                              this
                            )}
                            ref={ref => (this.playCheckboxHeader = ref)}
                          />
                        </PlayCheckBox>
                        <div style={{ width: '100%' }} />
                      </PlayHeader>
                      <ScrollingPlayWrap>
                        <ContentPlayWrap>
                          {(this.playstack || []).map((play, idx) => {
                            return (
                              <PlayCompWrap
                                key={`play-comp-${play.game_play_id}`}
                              >
                                <PlayCheckBox widthInPct="5">
                                  <input
                                    type="checkbox"
                                    value={play.checked}
                                    ref={ref =>
                                      (this[`play-checkbox${idx}`] = ref)
                                    }
                                    onChange={this.handlePlayCheckChange.bind(
                                      this,
                                      idx
                                    )}
                                  />
                                </PlayCheckBox>
                                <PlayComp item={play} />
                              </PlayCompWrap>
                            )
                          })}
                        </ContentPlayWrap>
                      </ScrollingPlayWrap>
                    </Section>
                    <Section justifyContent="center" marginTop="1.5">
                      <Label
                        font="pamainlight"
                        size="2"
                        color={'#d3d3d3'}
                        uppercase
                      >{`selected play(s): ${this.selectedPlaysCount}`}</Label>
                    </Section>
                    {/!*
                    <Section justifyContent="center" marginTop="6">
                      <Label
                        font="pamainregular"
                        size="2.5"
                        color={'#d3d3d3'}
                        uppercase
                        innerRef={ref => (this.refContinueLabel = ref)}
                      >
                        do you want to continue?
                      </Label>
                    </Section>
*!/}
                    <Section justifyContent="center" marginTop="6">
                      <ImportButton
                        id={'ref-import-button'}
                        locked={this.selectedPlaysCount < 1}
                        innerRef={ref => (this.refImportButton = ref)}
                        onClick={
                          this.selectedPlaysCount > 0
                            ? this.handleImportClick.bind(this)
                            : null
                        }
                      >
                        {this.activityIndicator}
                      </ImportButton>
                    </Section>
                  </Section>
                ) : this.isFinding ? (
                  <Section
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <ActivityIndicator color={'#d3d3d3'} height={5} />
                    <Label size="2.5" color={'#d3d3d3'} uppercase>
                      fetching playstack. please wait...
                    </Label>
                  </Section>
                ) : (
                  <IconImport />
                )}
              </Section>
            </Section>
          ) : this.isFinding ? (
            <Section
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              <ActivityIndicator color={'#d3d3d3'} height={5} />
              <Label size="2.5" color={'#d3d3d3'} uppercase>
                fetching game events to import
              </Label>
            </Section>
          ) : !this.events ? null : (
            <Section justifyContent="center">
              <Label font="pamainregular" size="3" color={'#d3d3d3'} uppercase>
                NO AVAILABLE GAME EVENT(S) PLAYSTACK FOR IMPORT
              </Label>
            </Section>
          )}

          <Section justifyContent={'center'} marginTop={6} style={{position:'absolute', bottom:0, padding: '4vh 0'}}>
            <Label
              font={'pamainregular'}
              size={2}
              color={'#ff0000'}
              uppercase
              nowrap
              cursor={'pointer'}
              innerRef={ref => (this.refCancelButton = ref)}
              onClick={this.handleCancelClick.bind(this)}
            >
              close and return back to game event
            </Label>
          </Section>
        </Wrapper>
      </Container>
    )
*/
  }
}

const Container = styled.div`
  position: absolute;
  width: inherit;
  height: inherit;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.95);
  overflow: hidden;
`

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const Section = styled.div`
  width: ${props => props.widthInPct || 100}%;
  height: ${props => props.height || ''};
  position: ${props => props.position || ''};
  bottom: ${props => props.bottom || ''};
  z-index: ${props => props.zIndex || ''};
  padding: ${props => props.padding || ''};
  background-color: ${props => props.backgroundColor || ''};
  margin-top: ${props => props.marginTop || 0}vh;
  margin-bottom: ${props => props.marginBottom || 0}vh;
  overfloow-y: ${props => props.overflowY || ''};
  display: flex;
  ${props => (props.direction ? `flex-direction:${props.direction}` : ``)};
  ${props =>
    props.justifyContent ? `justify-content:${props.justifyContent};` : ``};
  ${props => (props.alignItems ? `align-items:${props.alignItems};` : ``)};
`

const Label = styled.span`
  height: ${props => props.size * 0.8 || 3}vh;
  font-family: ${props => props.font || 'pamainregular'};
  font-size: ${props => props.size || 3}vh;
  color: ${props => props.color || '#ffffff'};
  line-height: ${props => props.lineHeight || 1};
  ${props => (props.uppercase ? 'text-transform: uppercase;' : '')} ${props =>
    props.italic ? 'font-style: italic;' : ''};
  ${props =>
    props.nowrap
      ? `white-space: nowrap; backface-visibility: hidden; -webkit-backface-visibility: hidden;`
      : ''};
  letter-spacing: ${props => (props.nospacing ? 0 : 0.1)}vh;
  cursor: ${props => props.cursor || 'default'};
  margin-bottom: ${props => props.marginBottom || 0}%;

  overflow: ${props => props.overflow || ''};
  scrollbar-width: none;
`

const FilterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1vh;
`

const CheckMark = styled.div`
  width: 2.5vh;
  height: 2.5vh;
  background-color: ${props => (props.checked ? '#2196F3' : '#eee')};
  margin-left: 0.5vw;
  &:after {
    display: inline-block;
    content: '';
    width: 100%;
    height: 100%;
    background-image: url(${props =>
      props.checked ? evalImage('check-icon.svg') : null});
    background-repeat: no-repeat;
    background-size: 60%;
    background-position: center;
  }
`

const GameEventItemWrap = styled.div`
  // width: 30%;
  width: ${props => props.width};
  margin-right: ${props => props.marginRight || 0}%;
  position: relative;
`

const TeamSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const TeamIconWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const TeamVS = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 2%;
`

const ImportButton = styled.div`
  height: ${props => 5}vh;
  background-color: #18c5ff;
  display: flex;
  align-items: center;
  cursor: ${props => (props.locked ? 'not-allowed' : 'pointer')};
  padding: 0 ${props => 1.5}vh 0 ${props => 1.5}vh;
  &:before {
    content: 'import playstack';
    font-family: pamainbold;
    fonts-size: ${props => 3}vh;
    color: #ffffff;
    line-height: 1;
    letter-spacing: ${props => 0.1}vh;
    text-transform: uppercase;
  }
`
const Blocker = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: ${props => props.backgroundColor || 'rgba(0, 0, 0, 0.9)'};
  z-index: 200;
`

const IconImport = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &:after {
    width: 100%;
    height: 100%;
    content: '';
    display: inline-block;
    background-image: url(${ImportExportArrowsIcon});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 15%;
  }
`

const IconArrowDown = styled.img`
  height: ${props => 3}vh;
`

const ScrollingPlayWrap = styled.div`
  position: relative;
  width: 90%;
  height: ${props => 50}vh;
  max-height: ${props => 50}vh;
  overflow-y: scroll;
  background-color: #eaeaea;
`

const ContentPlayWrap = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
`

const PlayCompWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`

const PlayHeader = styled.div`
  width: 90%;
  height: ${props => PCHeight}vh;
  border-top: ${props => 0.1}vh solid #ffffff;
  border-right: ${props => 0.1}vh solid #ffffff;
  border-left: ${props => 0.1}vh solid #ffffff;
  display: flex;
  flex-direction: row;
`

const PlayCheckBox = styled.div`
  width: ${props => props.widthInPct}%;
  height: ${props => PCHeight}vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.backgroundColor || '#ffffff'};
`
const FilterSection = styled.div`
  width: 100%;
  padding-left: 4%;
`

const CloseButton = styled.div`
  width: 10vw;
  height: 5vh;
  background-color: #c61a19;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:after {
    content: 'CLOSE';
    font-family: pamainlight;
    font-size: 2.5vh;
    line-height: 1;
    color: #fff;
    height: ${props => 2.5 * 0.8}vh;
    letter-spacing: 0.2vh;
  }
  &:hover {
    background-color: transparent;
    border: 0.4vh solid #c61a19;
    &:after {
      color: #c61a19;
    }
  }
`

const PCHeight = 4
const PCFontSize = PCHeight * 0.4
const PCContainer = styled.div`
  width: 100%;
  height: ${props => PCHeight}vh;
  margin-bottom: ${props => 0.3}vh;
  display: flex;
  justify-content: space-between;
`

const PCType = styled.div`
  position: relative;
  width: 20%;
  height: 100%;
  background-color: ${props => props.backgroundColor};
  font-family: pamainregular;
  font-size: ${props => PCFontSize}vh;
  text-transform: uppercase;
  color: #ffffff;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1%;
`

const PCPreset = styled.div`
  width: 15%;
  height: 100%;
  background-color: #ffffff;
  font-family: pamainregular;
  font-size: ${props => PCFontSize}vh;
  text-transform: uppercase;
  color: #000000;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1%;
`

const PCQuestion = styled.div`
  width: 35%;
  height: 100%;
  background-color: #ffffff;
  font-family: pamainregular;
  font-size: ${props => PCFontSize}vh;
  text-transform: uppercase;
  color: #000000;
  line-height: 1;
  display: flex;
  align-items: center;
  padding-left: 2%;
  margin-right: 1%;
`

const PCChoicesWrap = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
`

const PCChoice = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.backgroundColor || '#c61818'};
  font-family: pamainregular;
  font-size: ${props => PCFontSize}vh;
  color: #ffffff;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${props => props.marginRight || 0};
`

const PCTypCondition = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
`

const PCAnnounceHeader = styled.div`
  width: 40%;
  height: 100%;
  display: flex;
  background-color: #ffffff;
  margin-right: 1%;
  padding-left: 2%;
  text-align: center;
  text-transform: uppercase;
  padding-top: 1.5%;
  font-size: ${props => PCFontSize}vh;
  align-items: center;
`

const PCAnnounceMiddle = styled.div`
  width: 40%;
  height: 100%;
  display: flex;
  background-color: #ffffff;
  margin-right: 1%;
  padding-left: 2%;
  text-align: center;
  text-transform: uppercase;
  padding-top: 1.5%;
  font-size: ${props => PCFontSize}vh;
  align-items: center;
`

const PCAnnounceBottom = styled.div`
  width: 20%;
  height: 100%;
  display: flex;
  background-color: #ffffff;
  padding-left: 2%;
  text-align: center;
  text-transform: uppercase;
  padding-top: 1.5%;
  font-size: ${props => PCFontSize}vh;
`

const PlayColors = {
  liveplay: '#c61818',
  gamemaster: '#19d1bf',
  sponsor: '#495bdb',
  prize: '#9368aa',
  announce: '#000000',
  live: '#c61818',
}

const PlayComp = props => {
  let { item } = props

  return (
    <PCContainer>
      <PCType backgroundColor={PlayColors[item.type.toLowerCase()]}>
        <span>{item.type}</span>
        {(item.opinionQuestion ||
          (item.pmetadata &&
            item.pmetadata.public &&
            item.pmetadata.public.opinionQuestion)) && (
          <div
            style={{
              position: 'absolute',
              right: '5%',
              backgroundColor: '#EFDF18',
              color: '#000',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '1.7vh',
              height: '1.2vh',
              borderRadius: '0.2vh',
              fontFamily: 'pamainregular',
              fontSize: '0.8vh',
              cursor: 'pointer',
              paddingTop: '0.1vh',
            }}
          >
            {'OPN'}
          </div>
        )}
      </PCType>
      {'announce' === item.type.toLowerCase() ? (
        <PCTypCondition>
          <PCAnnounceHeader
            dangerouslySetInnerHTML={{ __html: item.announce_header }}
          />
          <PCAnnounceMiddle
            dangerouslySetInnerHTML={{ __html: item.announce_middle }}
          />
          <PCAnnounceBottom dangerouslySetInnerHTML={{ __html: '...' }} />
        </PCTypCondition>
      ) : (
        <PCTypCondition>
          <PCPreset>{item.preset_id}</PCPreset>
          <PCQuestion>{item.parent_question}</PCQuestion>
          <PCChoicesWrap>
            {item.choices.map((c, idx) => {
              return (
                <PCChoice
                  key={`${idx}-${c.sequence}`}
                  backgroundColor={PlayColors[(item.type || '').toLowerCase()]}
                  marginRight={idx + 1 < item.choices.length ? '0.2vh' : 0}
                >
                  {c.value}
                </PCChoice>
              )
            })}
          </PCChoicesWrap>
        </PCTypCondition>
      )}
    </PCContainer>
  )
}

const CMContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 1000;
`

const CMMessage = styled.div`
  position: relative;
  width: ${props => 40}vh;
  height: ${props => 25}vh;
  border-radius: ${props => 0.2}vh;
  background-color: #eaeaea;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CMContent = styled.div`
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const CMFooter = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const CMText = styled.span`
  font-family: pamainregular;
  font-size: ${props => 3}vh;
  font-color: #000000;
  text-transform: uppercase;
  line-height: 1;
`

const CMButton = styled.div`
  width: ${props => 12}vh;
  height: 60%;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:after {
    content: '${props => props.text}';
    font-family: pamainbold;
    font-size: ${props => 1.5}vh;
    color: #ffffff;
    line-height: 1;
    text-transform: uppercase;
  }
`

const ConfirmMessage = props => {
  return (
    <CMContainer>
      <CMMessage>
        <CMContent>
          <CMText>do you want to continue?</CMText>
        </CMContent>
        <CMFooter>
          <CMButton
            width={10}
            backgroundColor={'#317ECE'}
            text="yes"
            onClick={props.confirm}
          />
          <div style={{ width: '1vh' }} />
          <CMButton
            width={10}
            backgroundColor={'#DA1533'}
            text="no"
            onClick={props.cancel}
          />
        </CMFooter>
      </CMMessage>
    </CMContainer>
  )
}



// WEBPACK FOOTER //
// src/Components/ImportPlaystack/index.js